import {css, html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent.js'
import '@isceco/widget-library2/basic-elements/Filter/DateFilter.js'
import DateFilterItem from '@isceco/widget-library2/basic-elements/Filter/DateFilterItem.js'
import ExportService from './ExportService.js'

export default class Export extends WebComponent {

  static get EVENT_KEYS() {
    return {
      RELOAD_TRIGGERED: "isceco-reload-triggered"
    }
  }

  get translationFile() {
    return './views/Admin/i18n.json'
  }

  get css() {
    return css`
      isceco-title:first-of-type {
        display: block;
        margin-top: -20px;
      }

      .filter {
        flex-grow: 1;
        margin-bottom: 15px;
      }
      isceco-date-filter {
        margin: 0;
        display: block;
      }
    `
  }

  constructor() {
    super()
    this.exportService = new ExportService()
    this.startDate = this.addDays(new Date(), -14);
    this.defaultEndDate = this.addDays(new Date(), +13);
    this.endDate = this.addDays(new Date(), +13);
    this.dateFilters = []
  }

  connectedCallback() {
    super.connectedCallback()
    document.addEventListener(Export.EVENT_KEYS.RELOAD_TRIGGERED, this.updateFilter)

    this.dateFilters = [
      new DateFilterItem({
        start: offsetDate({m: -3}),
        end: this.getDateString(this.defaultEndDate)
      }, 'admin.export.date.filter.last.months', {months: 3}),
      new DateFilterItem({
        start: offsetDate({m: -6}),
        end: this.getDateString(this.defaultEndDate)
      }, 'admin.export.date.filter.last.months', {months: 6}),
      new DateFilterItem({
        start: offsetDate({y: -1}),
        end: this.getDateString(this.defaultEndDate),
      }, 'admin.export.date.filter.lastYear')
    ]

    this.render()
  }

  disconnectedCallback() {
    document.removeEventListener(Export.EVENT_KEYS.RELOAD_TRIGGERED, this.updateFilter)
  }

  getTemplate() {
    return html`
      <isceco-title text="${this.i18n.translate(`admin.export.title`)}"></isceco-title>
      <div style="display: flex; flex-wrap: wrap;">
        <div class="filter">
          <isceco-date-filter
            .i18n="${this.i18n}"
            label="${this.i18n.translate('admin.export.date.filter.label')}"
            .items="${this.dateFilters}"
            key="date">
          </isceco-date-filter>
        </div>
        <div style=" display:flex; flex-direction:column; flex-grow: 1; gap: 10px;">
          <isceco-button id="exportverbrauch" variant="tertiary" size="small" icon="download"
                         text="${this.i18n.translate(`admin.export.verbrauchsdaten.download`)}"
                         @click="${_ => {
                           const startDateString = this.startDate.toISOString().split('T')[0];
                           const endDateString = this.endDate.toISOString().split('T')[0];
                           this.exportService.getVerbrauch(startDateString, endDateString)
                             .then(async response => {
                               await this.download(response, 'Verbrauchsdaten_Export.csv');
                             }).catch(_1 => this.reload())
                         }}"
          ></isceco-button>
          <isceco-button id="exportVerbrauchsprognose" variant="tertiary" size="small" icon="download"
                         text="${this.i18n.translate(`admin.export.verbrauchsprognosedaten.download`)}"
                         @click="${_ => {
                           const startDateString = this.startDate.toISOString().split('T')[0];
                           const endDateString = this.endDate.toISOString().split('T')[0];
                           this.exportService.getVerbrauchprognose(startDateString, endDateString)
                             .then(async response => {
                               await this.download(response, 'Verbrauchsprognosedaten_Export.csv');
                             }).catch(_1 => this.reload())
                         }}"
          ></isceco-button>
          <isceco-button id="exportNominierteLeistungEin" variant="tertiary" size="small" icon="download"
                         text="${this.i18n.translate(`admin.export.nominierteleistung.einspeisepunkt.download`)}"
                         @click="${_ => {
                           const startDateString = this.startDate.toISOString().split('T')[0];
                           const endDateString = this.endDate.toISOString().split('T')[0];
                           this.exportService.getNominierteLeistungEinspeisepunkt(startDateString, endDateString)
                             .then(async response => {
                               await this.download(response, 'NominierteLeistungEinspeisepunkt_Export.csv');
                             }).catch(_1 => this.reload())
                         }}"
          ></isceco-button>
          <isceco-button id="exportNominierteLeistungtra" variant="tertiary" size="small" icon="download"
                         text="${this.i18n.translate(`admin.export.nominierteleistung.transitleitung.download`)}"
                         @click="${_ => {
                           const startDateString = this.startDate.toISOString().split('T')[0];
                           const endDateString = this.endDate.toISOString().split('T')[0];
                           this.exportService.getNominierteLeistungTransitleitung(startDateString, endDateString)
                             .then(async response => {
                               await this.download(response, 'NominierteLeistungTransitleitung_Export.csv');
                             }).catch(_1 => this.reload())
                         }}"
          ></isceco-button>
          <isceco-button id="exportMeterdatenEin" variant="tertiary" size="small" icon="download"
                         text="${this.i18n.translate(`admin.export.meterdaten.einspeisepunkt.download`)}"
                         @click="${_ => {
                           const startDateString = this.startDate.toISOString().split('T')[0];
                           const endDateString = this.endDate.toISOString().split('T')[0];
                           this.exportService.getMeterdatenEinspeisepunkt(startDateString, endDateString)
                             .then(async response => {
                               await this.download(response, 'MeterdatenEinspeisepunkt_Export.csv');
                             }).catch(_1 => this.reload())
                         }}"
          ></isceco-button>
          <isceco-button id="exportMeterdatenTra" variant="tertiary" size="small" icon="download"
                         text="${this.i18n.translate(`admin.export.meterdaten.transit.download`)}"
                         @click="${_ => {
                           const startDateString = this.startDate.toISOString().split('T')[0];
                           const endDateString = this.endDate.toISOString().split('T')[0];
                           this.exportService.getMeterdatenTransitleitung(startDateString, endDateString)
                             .then(async response => {
                               await this.download(response, 'MeterdatenTransit_Export.csv');
                             }).catch(_1 => this.reload())
                         }}"
          ></isceco-button>
          <isceco-button id="exportAngebot" variant="tertiary" size="small" icon="download"
                         text="${this.i18n.translate(`admin.export.angebot.download`)}"
                         @click="${_ => {
                           const startDateString = this.startDate.toISOString().split('T')[0];
                           const endDateString = this.endDate.toISOString().split('T')[0];
                           this.exportService.getAngebot(startDateString, endDateString)
                             .then(async response => {
                               await this.download(response, 'VerfuegbaresAngebot_Export.csv');
                             }).catch(_1 => this.reload())
                         }}"
          ></isceco-button>
          <isceco-button id="exportTemperaturdaten" variant="tertiary" size="small" icon="download"
                         text="${this.i18n.translate(`admin.export.temperaturdaten.download`)}"
                         @click="${_ => {
                           const startDateString = this.startDate.toISOString().split('T')[0];
                           const endDateString = this.endDate.toISOString().split('T')[0];
                           this.exportService.getTemperaturdaten(startDateString, endDateString)
                             .then(async response => {
                               await this.download(response, 'Temperaturdaten_Export.csv');
                             }).catch(_1 => this.reload())
                         }}"
          ></isceco-button>


        </div>
      </div>
    `
  }

  async download(response, fileName) {
    // Get the CSV content as a Blob
    const csvBlob = await response.blob();

    // Create a link element and trigger the download
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(csvBlob);
    downloadLink.download = fileName // Set the filename
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  addDays(date, days) {
    date.setDate(date.getDate() + days);
    return date;
  }

  getDateString(date) {
    return new Date(date).toISOString().split('T')[0];
  }

  updateFilter = event => {
    if (event.detail.value.from === null || event.detail.value.to === null) {
      this.startDate = this.defaultStartDate
      this.endDate = this.defaultEndDate
    } else {
      this.startDate = new Date(event.detail.value.from)
      this.endDate = new Date(event.detail.value.to)
    }
  }

}
customElements.define('gasmonitoring-frontend-admin-export', Export)
